import { jsPDF } from 'jspdf'
import { fmtMoney, fmtDatePDF, addRiverbendHeader, addPoolsHeaderFancy as addPoolsHeader, addFooter } from './pdfHelpers'
import { generateProposalPDF } from './proposalPDF'

var WHO_WE_ARE_RIVERBEND = 'Riverbend Clearing Co. is a Michigan-based company specializing in land clearing and forestry services. We are committed to delivering efficient, professional, and environmentally responsible land management solutions. Our services cater to residential, commercial, agricultural, and municipal clients, offering a comprehensive range of options including forestry mulching, brush and tree removal, timber stand improvement, and site preparation. Our dedicated team prioritizes clear communication, upholds safe practices, and ensures the delivery of clean, usable land that is ready for its next purpose, all while preserving the natural character and long-term value of each property.'

var RIVERBEND_DISCLAIMER = 'Commercial Land Clearing Disclaimer - Riverbend Clearing Co.\n\n'
  + 'Riverbend Clearing Co. performs all land clearing, forestry mulching, stump removal, and site preparation services under the terms and conditions outlined in this agreement. The client acknowledges and agrees to the following:\n\n'
  + '1. Scope & Variations\n'
  + 'The scope of work is based on the site conditions and information provided at the time of estimate. Hidden debris, underground obstructions, large root systems, or unexpected grading issues may result in additional costs billed at the agreed hourly rate.\n\n'
  + '2. Access & Site Conditions\n'
  + 'The client is responsible for ensuring safe and sufficient access for heavy equipment. Any delays due to access limitations, weather, permitting, or third-party site restrictions are subject to standby charges.\n\n'
  + '3. Utility Marking & Damage Liability\n'
  + 'The client must ensure all underground utilities are properly marked prior to work. Riverbend Clearing Co. is not responsible for damage to unmarked or inaccurately marked utilities.\n\n'
  + '4. Erosion Control & Restoration\n'
  + 'Unless specifically included in the proposal, erosion control, reseeding, grading beyond stump hole backfill, and topsoil restoration are excluded from this contract.\n\n'
  + '5. Environmental & Permitting Compliance\n'
  + 'The client is responsible for obtaining all environmental permits and approvals required for land clearing, tree removal, or material disposal prior to project commencement.\n\n'
  + '6. Weather Delays & Force Majeure\n'
  + 'Work schedules may be affected by adverse weather, equipment failure, or other unforeseen conditions beyond Riverbend Clearing Co.\'s control. Additional time or rescheduling shall not constitute a breach of contract.\n\n'
  + '7. Material Ownership\n'
  + 'Unless stated otherwise, all wood, mulch, and cleared debris become the property of Riverbend Clearing Co. for removal and disposal at their discretion.\n\n'
  + '8. Payment Terms\n'
  + 'Payment is due as outlined in the contract or invoice schedule. Unpaid balances beyond 30 days may incur finance charges and collection fees.\n\n'
  + '9. Warranty & Limitations\n'
  + 'Riverbend Clearing Co. warrants workmanship and equipment performance consistent with industry standards. No warranty is made on soil stability, regrowth, or environmental impact following completion.'

var POOL_DISCLAIMER = 'Terms & Conditions - CP Quality Pools\n\n'
  + '1. Payment\n'
  + 'Payment is due upon completion on the day of installation. No deposit is required for above ground pool installations.\nFor inground pool projects: 50% is due after the first day of work, with the remaining balance due upon project completion.\n\n'
  + '2. Warranty\n'
  + '1-year warranty on installation workmanship. Manufacturer warranty on pool and liner components per their terms.\n\n'
  + '3. Cancellation\n'
  + 'Deposits are non-refundable if cancelled within 7 days of scheduled install date.\n\n'
  + '4. Site Preparation\n'
  + 'Customer is responsible for ensuring clear, level access to the install site. Additional charges may apply for difficult access, underground obstructions, or excessive grading.\n\n'
  + '5. Permits\n'
  + 'Customer is responsible for obtaining any required permits unless otherwise noted in this estimate.\n\n'
  + '6. Scheduling\n'
  + 'Installation dates are weather-dependent. Delays due to weather are not grounds for cancellation or refund.\n\n'
  + '7. Validity\n'
  + 'This quote is valid for the period noted above. Prices are subject to change after expiration.'

var FOOTER_RIVERBEND = 'Riverbend Contracting Co. | 11260 Dunham Road | Hartland, Michigan 48353 | 8109236229 | Carspie99@gmail.com | Riverbendcontractingco.com'
var FOOTER_POOLS = 'CP Quality Pools | 11260 Dunham Rd, Hartland, MI 48353 | (810) 923-6229 | pietilagroup.com'

// options: the bid's bid_options rows (coping choices) — used by pool proposals.
export function generateQuotePDF(bid, lines, options) {
  if (bid.business_id === 'pools') return generateProposalPDF(bid, lines, options || [])
  var doc = new jsPDF()
  var isPool = bid.business_id === 'pools'
  var clientLines = lines.filter(function(l) { return l.category !== 'notes' && parseFloat(l.total_cost) > 0 })
  var notesLine = lines.find(function(l) { return l.category === 'notes' })
  var disclaimers = bid.disclaimers || (isPool ? POOL_DISCLAIMER : RIVERBEND_DISCLAIMER)

  // ===== PAGE 1 =====

  // Header
  if (isPool) {
    addPoolsHeader(doc)
  } else {
    addRiverbendHeader(doc)
  }

  var y = 42

  // Project name (italic, blue-ish)
  if (bid.job_name) {
    doc.setFontSize(11)
    doc.setFont('helvetica', 'italic')
    doc.setTextColor(60, 100, 160)
    doc.text(bid.job_name, 14, y)
    y += 8
  }

  // Recipient block
  doc.setFontSize(8)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('RECIPIENT:', 14, y)
  y += 5

  doc.setFontSize(12)
  doc.setFont('helvetica', 'bold')
  doc.text(bid.client_name || 'N/A', 14, y)
  y += 5

  doc.setFontSize(10)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(60, 60, 60)
  if (bid.site_address) { doc.text(bid.site_address, 14, y); y += 5 }
  if (bid.client_phone) { doc.text(bid.client_phone, 14, y); y += 5 }
  if (bid.client_email) { doc.text(bid.client_email, 14, y); y += 5 }

  // Estimate box (right side)
  var boxX = 130; var boxY = 42
  doc.setFillColor(90, 90, 90)
  doc.rect(boxX, boxY, 66, 9, 'F')
  doc.setFontSize(11)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(255, 255, 255)
  doc.text('Estimate #' + (bid.estimate_number || '--'), boxX + 3, boxY + 6.5)

  // Sent on line
  doc.setTextColor(80, 80, 80)
  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.text('Sent on', boxX + 3, boxY + 16)
  doc.setDrawColor(180, 180, 180)
  doc.line(boxX + 20, boxY + 16.5, boxX + 63, boxY + 16.5)

  if (bid.valid_until) {
    doc.setFontSize(8)
    doc.text('Valid until: ' + fmtDatePDF(bid.valid_until), boxX + 3, boxY + 22)
  }

  // Total box
  doc.setFillColor(90, 90, 90)
  doc.rect(boxX, boxY + 25, 66, 9, 'F')
  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(255, 255, 255)
  doc.text('Total', boxX + 3, boxY + 31)
  doc.setFontSize(12)
  doc.setFont('helvetica', 'bold')
  doc.text(fmtMoney(bid.total), boxX + 63, boxY + 31, { align: 'right' })

  // Separator
  y = Math.max(y, boxY + 42) + 4
  doc.setDrawColor(220, 180, 50)
  doc.setLineWidth(1)
  doc.line(14, y, 196, y)
  y += 8

  // "Who we are" section (Riverbend only)
  if (!isPool) {
    doc.setFontSize(12)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(0, 0, 0)
    doc.text('Who we are', 14, y)
    y += 6

    doc.setFontSize(8.5)
    doc.setFont('helvetica', 'normal')
    doc.setTextColor(60, 60, 60)
    var whoLines = doc.splitTextToSize(WHO_WE_ARE_RIVERBEND, 178)
    doc.text(whoLines, 14, y)
    y += whoLines.length * 3.8 + 8
  }

  // Scope/description
  if (bid.description) {
    doc.setFontSize(9)
    doc.setFont('helvetica', 'normal')
    doc.setTextColor(50, 50, 50)
    var scopeLines = doc.splitTextToSize(bid.description, 178)
    if (y + scopeLines.length * 4 > 260) { doc.addPage(); y = 25; if (!isPool) addRiverbendHeader(doc); else addPoolsHeader(doc); y = 42 }
    doc.text(scopeLines, 14, y)
    y += scopeLines.length * 4 + 6
  }

  // Product/Service table header
  if (y > 235) { doc.addPage(); y = 25 }
  doc.setFillColor(240, 240, 240)
  doc.rect(14, y - 1, 182, 8, 'F')
  doc.setDrawColor(200, 200, 200)
  doc.setLineWidth(0.3)
  doc.rect(14, y - 1, 182, 8, 'S')

  doc.setFontSize(8)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('Product/Service', 16, y + 4)
  doc.text('Description', 62, y + 4)
  doc.text('Total', 185, y + 4, { align: 'right' })

  // Column divider lines
  doc.line(58, y - 1, 58, y + 7)
  doc.line(168, y - 1, 168, y + 7)
  y += 10

  // Line items
  doc.setFont('helvetica', 'normal')
  doc.setFontSize(9)
  clientLines.forEach(function(l) {
    if (y > 255) { doc.addPage(); y = 25 }

    var descText = l.description || ''
    var descWrapped = doc.splitTextToSize(descText, 102)
    var rowHeight = Math.max(descWrapped.length * 4.2, 7)

    // Light border
    doc.setDrawColor(220, 220, 220)
    doc.setLineWidth(0.2)
    doc.line(14, y + rowHeight, 196, y + rowHeight)

    doc.setTextColor(30, 30, 30)
    // Category/service name (left col)
    var category = l.category || 'Service'
    if (category === 'pool') category = 'Pool Install'
    else if (category === 'extra') category = 'Extra/Add-on'
    else if (category === 'custom') category = 'Custom'
    else if (category === 'trees') category = 'Tree Removal'
    else if (category === 'mulching') category = 'Mulching'
    else if (category === 'demo') category = 'Demolition'
    else if (category === 'equipment') category = 'Equipment'
    else category = category.charAt(0).toUpperCase() + category.slice(1)

    doc.setFont('helvetica', 'normal')
    doc.text(category, 16, y + 4)

    // Description (middle col)
    doc.setFontSize(8.5)
    doc.text(descWrapped, 62, y + 4)

    // Total (right col)
    doc.setFontSize(9)
    doc.setFont('helvetica', 'normal')
    doc.text(fmtMoney(l.total_cost), 185, y + 4, { align: 'right' })

    y += rowHeight + 2
  })

  // Notes line
  if (notesLine && notesLine.description) {
    doc.setFontSize(8)
    doc.setFont('helvetica', 'italic')
    doc.setTextColor(100, 100, 100)
    var nLines = doc.splitTextToSize(notesLine.description, 178)
    doc.text(nLines, 14, y + 4)
    y += nLines.length * 3.5 + 4
  }

  // Gold separator
  y += 2
  doc.setDrawColor(220, 180, 50)
  doc.setLineWidth(1)
  doc.line(14, y, 196, y)
  y += 8

  // Total row
  doc.setFillColor(245, 245, 245)
  doc.rect(130, y - 3, 66, 10, 'F')
  doc.setDrawColor(180, 180, 180)
  doc.rect(130, y - 3, 66, 10, 'S')
  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('Total', 134, y + 3.5)
  doc.setFontSize(12)
  doc.text(fmtMoney(bid.total), 192, y + 3.5, { align: 'right' })

  // ===== PAGE 2 - DISCLAIMERS =====
  doc.addPage()
  if (isPool) { addPoolsHeader(doc) } else { addRiverbendHeader(doc) }

  y = 42
  doc.setFontSize(8.5)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(40, 40, 40)

  var dLines = disclaimers.split('\n')
  dLines.forEach(function(line) {
    if (y > 265) { doc.addPage(); y = 25 }
    var trimmed = line.trim()
    if (!trimmed) { y += 3; return }

    // Check if it's a section header (starts with number + dot or is the title)
    var isHeader = /^\d+\./.test(trimmed) || trimmed.indexOf('Disclaimer') > -1 || trimmed.indexOf('Terms &') > -1
    if (isHeader) {
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(9)
    } else {
      doc.setFont('helvetica', 'normal')
      doc.setFontSize(8.5)
    }

    var wrapped = doc.splitTextToSize(trimmed, 176)
    wrapped.forEach(function(wl) {
      if (y > 265) { doc.addPage(); y = 25 }
      doc.text(wl, 14, y)
      y += 3.8
    })
    y += 1
  })

  // Signature block
  y += 10
  if (y > 255) { doc.addPage(); y = 25 }
  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('Signature:', 14, y)
  doc.setFont('helvetica', 'normal')
  doc.setDrawColor(0, 0, 0)
  doc.setLineWidth(0.3)
  doc.line(40, y + 0.5, 110, y + 0.5)
  doc.text('Date:', 120, y)
  doc.line(135, y + 0.5, 180, y + 0.5)

  // Footer on every page
  addFooter(doc, isPool ? FOOTER_POOLS : FOOTER_RIVERBEND)

  return doc
}

export function getDefaultDisclaimers(businessId) {
  return businessId === 'pools' ? POOL_DISCLAIMER : RIVERBEND_DISCLAIMER
}
